/**
 * EPA-7 — identity of EPA's nonattainment-area boundary service, shared by the
 * `epa-attainment` provider, the SED compiler and its tests. Dependency-free,
 * so the SED compiler cites the service without importing the provider.
 */

/** EPA OAR/OAQPS "Nonattainment Areas and Designations, United States" ArcGIS MapServer. */
export const EPA_NONATTAINMENT_AREAS_SERVICE_URL =
  'https://gispub.epa.gov/arcgis/rest/services/OAR_OAQPS/NonattainmentAreas/MapServer';

/** Attribution for provider source rows and the SED source contribution. */
export const EPA_NONATTAINMENT_BOUNDARIES_SOURCE =
  'EPA OAR/OAQPS nonattainment-area boundaries (NonattainmentAreas MapServer), point-in-polygon at the site query point';

/** Provider source-row field of the boundary lookup; the SED compiler reads its retrieval time. */
export const EPA_NONATTAINMENT_BOUNDARIES_FIELD = 'epaNonattainmentBoundaries';
